module.exports = __webpack_public_path__ + "static/CustomBgMobile-b91e1c8434e9f942f65fbacfd2705699.png";